const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgCouch1 = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 1024.09 436.1",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "198b4205-a0ab-4c8a-a8f7-7dd6d7677ab5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.41,33.1c-36.3,27.1-10.6,203.8,26,215.6,36.3,11.7,804.2,20,837,3.6s76.7-195,16-227.4c-76.5-40.8-832.4-26.5-879,8.2",
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54d03cf1-f171-4131-add4-8c191b53a0d5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M626.91,39.8c16.6-10.6,56.9-1.8,97.5.9,16,1.1,32.9.1,47.6-.9,22.5-1.5,40-3,42,2.9,3.3,9.7-10.2,72.1-8.5,96.5s9.9,65.1,8.7,72.3-88.3-3.4-102.3-3.4-91.4,11.6-92-1.1,11.3-51.5,11.7-69.6-9.5-94.5-4.7-97.6",
    style: {
      fill: "none"
    }
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "path146",
    d: "M66.41,33.1c-36.3,27.1-10.6,203.8,26,215.6,36.3,11.7,804.2,20,837,3.6s76.7-195,16-227.4c-76.5-40.8-832.4-26.5-879,8.2",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g148"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#198b4205-a0ab-4c8a-a8f7-7dd6d7677ab5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g150"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path156",
    d: "M133,196.6c-2.5-18.8-4.9-37.7-7.6-56.5-2.9-21.3-6-42.6-9.1-63.9l-4-27.2c.6-.2,1.2-.3,1.8-.5,1.7,9.1,3.3,18.2,4.9,27.2,3.7,21.2,6.9,42.5,9.9,63.8,2.6,18.9,5,37.8,7,56.8a13.58,13.58,0,0,1-2.9.3M108.41,22h0c.2,0,.4-.1.6-.1h0a1.27,1.27,0,0,1-.6.1",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path158",
    d: "M190.51,194.5c-2.8-20.8-5.3-41.7-7.8-62.5-2.6-21.9-5.1-43.7-7.4-65.6l-2.9-27.9a11.08,11.08,0,0,1,1.9-.2L178,66.1c2.9,21.8,5.6,43.7,8.2,65.5q3.75,31.35,7.1,62.9a13.09,13.09,0,0,0-2.8,0M170.11,14.9h0c.3,0,.6-.1.8-.1h0a2.49,2.49,0,0,0-.8.1",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path160",
    d: "M247.41,193.5l-2.1-22.1-3.1-34.9c-2-23.3-3.9-46.5-5.6-69.9l-2.5-34.7c.5,0,1.1-.1,1.7-.1l3.5,34.6q3.45,34.8,6.4,69.8l2.9,34.9,1.8,22.3c-1,.1-2,.1-3,.1M232.71,10.1h0",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path162",
    d: "M314.41,193.3h-3.1l-3.5-59.3c-1.4-24.4-3.1-48.9-4.7-73.3l-1.3-18.3-1.2-15c.6,0,1.2-.1,1.8-.1L304,42.2l1.8,18.3c2.3,24.4,4.1,48.8,5.6,73.3q1.65,29.7,3,59.5M298.91,6.5h0a2.77,2.77,0,0,0,.9-.1h0a2.77,2.77,0,0,0-.9.1",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path164",
    d: "M376.11,193.5h-3.2c-1.4-21.2-2.8-42.4-4-63.6q-2.25-38.25-4.2-76.6l-1.5-29.1c.6,0,1.3-.1,1.9-.1.8,9.7,1.5,19.3,2.3,29,2,25.5,3.5,51,5.1,76.5l3.6,63.9",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path166",
    d: "M441.81,193.9h-3.2q-2.1-30.75-3.9-61.7l-2.2-39.5c-.8-13.2-1.5-26.3-2.2-39.5l-1.7-31.5a10.87,10.87,0,0,0,1.8-.1c.8,10.5,1.6,20.9,2.4,31.4l1.5,19.7,1.3,19.7,2.5,39.5,3.7,62",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path168",
    d: "M495.61,34.8c-.8,0-1.5-.1-2.2-.1l-.2-14.5h1.9l.5,14.6",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path170",
    d: "M566.21,41c-.8,0-1.6-.1-2.5-.1l-.3-13.8-.2-7.9h1.9l.4,7.8.7,14",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path172",
    d: "M630.71,37.9l.2-19h2l.3,18.1c-.9.3-1.7.6-2.5.9",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path174",
    d: "M700.21,38.6a17.85,17.85,0,0,0-2.3-.2l.8-19h1.8l-.3,19.2",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path176",
    d: "M759.61,40.6l1-20.3h1.8L762,40.4a19.42,19.42,0,0,1-2.4.2",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path178",
    d: "M825.41,189.6c1.2-20.7,2.3-41.4,3-62.1.9-24.9,1.3-49.9,1.4-74.8l-.1-18.7-.2-11.9c.6,0,1.2.1,1.9.1l.5,11.7.6,18.7c.6,25,.3,50-.5,75-.7,20.6-1.8,41.1-3.4,61.7a31.63,31.63,0,0,1-3.2.3",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path180",
    d: "M902,148.2c2.1-25.1,3.6-50.2,5-75.3l.9-19,.8-19,.3-8.8c.4,0,.9.1,1.3.1V35L910,54l-.5,19c-.6,21-1.7,42.1-3.2,63-1.4,4.1-2.9,8.2-4.3,12.2",
    style: {
      fill: "#577d7a"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path182",
    d: "M668.91,253.4a3.55,3.55,0,0,1-.2-1,3,3,0,0,1,.2,1m-11.1-37.8c-2.4-.3-11.6-.8-25.2-1.4V214h4.1c6.3,0,11-.3,13.3-1.2,1.9-.1,3.8-.1,5.8-.2h0c10.5-.5,21.7-1.5,31.5-2.5h0c2.2-.2,4.4-.4,6.4-.6v4.8c-21.7.8-35.7,1.3-35.9,1.3h0m38.7-1.4c0-1.7.1-3.3.1-4.9,1.5-.1,2.9-.3,4.2-.4h0c4.9-.4,8.8-.7,11.1-.7h0c5.6,0,22.8,1.7,41.6,3.3v.7c-21.4.7-41.1,1.4-57,2m-66.3-.1c-16.4-.7-38.7-1.5-63.3-2.3,0-.8.1-1.7.1-2.5,18,1.5,44.6,4.1,63.2,4.6v.2m125.9-2.1v-.4l3.2.3c-1,0-2.1,0-3.2.1M564,211.7c-13.8-.4-28.2-.9-42.7-1.3,12.7-1.2,23.5-2.3,28-2.3h0c2.7,0,7.9.4,14.8,1l-.1,2.6m-493.4-.3c-.3-1.3-.6-2.7-1-4a23,23,0,0,0,3.7,3.9,21,21,0,0,0-2.7.1m306.4-.5-.3-4.7-.7-12.7c20.6.1,41.5.3,62.6.4.3,5,.7,9.9,1,14.9-9-.1-17.3-.2-24.8-.2-21.1,0-35.2.5-36.9,1.6-.2.1-.5.4-.9.7m-261.1-.5c2.9-1.2,4.6-5.9,5.3-13,3.8-.3,7.8-.5,11.8-.7.3,2.5.7,5,1,7.5l.8,5.9-18.9.3m258.2-.3c-7.2-1.3-29.5-1.9-59.1-2v-1l-.6-13.8c19,0,38.6.1,58.5.2l.9,12.9c.1,1.2.2,2.5.3,3.7m-236.7-.1c-.2-2.1-.4-4.1-.6-6.2-.2-2.4-.5-4.9-.8-7.3,16.4-.9,34.7-1.5,54.6-2,.1,1,.3,2,.4,3l1.6,11.6c-19.6.3-38.4.6-55.2.9m57.5-.9-1.2-11.9c-.1-.9-.2-1.8-.3-2.8,17-.4,35.1-.7,54-.8l1.2,12.8.2,2c-17.8.2-36.1.4-53.9.7m263.3-.1c-5.3-.1-10.5-.2-15.5-.2l-.9-14.9c5,0,10,.1,15.1.1h1.8a66.13,66.13,0,0,0-1.4,13,2.66,2.66,0,0,0,.9,2m-206.6-.6-.2-2.3-1-12.6c18.6-.2,38.1-.2,58.1-.2h2.6l.8,14,.1.9h-11.7c-15.1-.1-31.6,0-48.7.2",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path184",
    d: "M134.81,210.1l-.8-5.9c-.3-2.5-.7-5-1-7.5,1-.1,1.9-.1,2.9-.2.3,2.4.5,4.9.8,7.3.2,2.1.4,4.1.6,6.2a20.9,20.9,0,0,0-2.5.1",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path186",
    d: "M192.51,209.1l-1.6-11.6c-.1-1-.3-2-.4-3,.9,0,1.9-.1,2.8-.1.1.9.2,1.8.3,2.8l1.2,11.9h-2.3",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path188",
    d: "M248.81,208.4l-.2-2-1.2-12.8h3.1l1,12.6.2,2.3c-1.1-.1-2-.1-2.9-.1",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path190",
    d: "M315,208.2h-2.9l-.1-.9-.8-14h3.1l.6,13.8.1,1.1",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path192",
    d: "M376,211.8l.3-.3h0c.6-.5-.3-.9-2.3-1.3-.1-1.3-.2-2.5-.3-3.8l-.9-12.9H376l.7,12.7.3,4.7c-.2.2-.6.5-1,.9",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path194",
    d: "M442.71,208.8h-3c-.3-5-.7-9.9-1-14.9h3.2l.8,14.9",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path196",
    d: "M566.91,211.8c-1,0-1.9-.1-2.9-.1V209a26.42,26.42,0,0,0,2.9.2v2.6",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path198",
    d: "M632.61,214.2c-.8,0-1.6-.1-2.4-.1v-.2c.8,0,1.6.1,2.4.1v.2",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path200",
    d: "M693.81,214.3v-4.8l2.9-.3c0,1.7-.1,3.3-.1,4.9-1,.1-1.9.2-2.8.2",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path202",
    d: "M753.51,212.1v-.7c.9.1,1.8.1,2.7.2v.4c-.9,0-1.8.1-2.7.1",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path204",
    d: "M814.31,209.8v-.3c0-3.8-.9-10.7-2.1-19l13.2-.9c-.3,4.2-.5,8.5-.8,12.7-.1,2.4-.3,4.8-.4,7.2l-9.9.3m12.7-.4.6-6.9c.4-4.4.7-8.8,1-13.1,28.5-2.2,50.9-5.1,65.1-9.2-2.3,13.7-1.8,23.7,2.5,25.7h0c.2.1.3.2.5.2,0,.3-.1.5-.1.7-20.1.8-44.3,1.7-69.6,2.6m124.2-1.6a4.17,4.17,0,0,0-4.2-2.6h-1.9c3.1-4.5,5.8-10.6,7.8-18.9,3.5-14.4,8.5-28.3,13-41.2-4.5,21.1-9.5,42.6-14.7,62.7m22.4-85.3c.7-2.2,1.2-4.3,1.8-6.4-.1,1.7-.2,3.3-.3,5a10,10,0,0,0-1.5,1.4m1.5-35.6c-2.6-4.9-7.2-8.6-14.5-11h-.5a15.31,15.31,0,0,0-4.7-.7c1.9-15.1,2-29.8.2-42.4,11.6,11.8,17.6,31.5,19.5,54.1",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path206",
    d: "M824.21,209.5c.2-2.4.3-4.8.4-7.2.3-4.2.5-8.5.8-12.7,1.1-.1,2.1-.2,3.2-.2-.3,4.4-.7,8.8-1,13.1l-.6,6.9c-.9,0-1.9.1-2.8.1",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path208",
    d: "M896.61,206.9c0-.2.1-.5.1-.7.5.2.9.5,1.4.7a7.52,7.52,0,0,0-1.5,0",
    style: {
      fill: "#4c726f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path210",
    d: "M946.21,25.4a2.18,2.18,0,0,1-.8-.5C912.71,7.4,755.51,0,582.81,0c-77.5,0-158.1,1.5-232.1,4.2,74-2.7,154.6-4.2,232.1-4.2,172.7,0,329.9,7.4,362.6,24.9a3.51,3.51,0,0,0,.8.5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path212",
    d: "M51,124.8a14.29,14.29,0,0,0-1.4-2c-.2-3.2-.4-6.4-.5-9.6.5,3.7,1.2,7.6,1.9,11.6M49,91.9c.9-27.7,6.2-50.4,17.4-58.8,5.3-4,20-7.7,42-11.1l4,27a116.78,116.78,0,0,0-20,6.9,50.77,50.77,0,0,0-19.5,16.9h-.7a13.33,13.33,0,0,0-2.8.3h-.6c-12.2,2.5-17.9,9.2-19.8,18.8m65.2-43.3c-.3-1.5-.6-3-.8-4.5-1.5-7.4-2.9-14.8-4.4-22.1,16.6-2.5,37.3-4.9,61.2-7.1.6,6.2,1.2,12.4,1.8,18.5l.5,5c-23.6,3-43.3,6.4-58.3,10.2m60.1-10.4-.7-5c-.9-6.1-1.8-12.3-2.6-18.4,18.8-1.7,39.5-3.3,61.7-4.7.5,7.2.9,14.4,1.4,21.7v.3c-21.8,1.8-41.9,3.8-59.8,6.1m61.5-6.3v-.3c-.8-7.2-1.5-14.4-2.3-21.5,20.6-1.3,42.5-2.5,65.4-3.6l1.4,17.6.3,3.3q-34.35,2-64.8,4.5m716.5-2.2c-12-1.3-26.1-2.4-41.9-3.5V15.5a2.77,2.77,0,0,0-.9-.1v.7l-.4,10.2c-22.7-1.5-48.9-2.8-77.7-3.8l-.3-7-.6-8.4c-.4,0-.9-.1-1.3-.1l.2,8.6.1,6.8c-21.1-.8-43.6-1.4-67.1-1.9l.1-4.7c0-4.1.1-8.2.1-12.3h-1.2l-.6,12.3-.2,4.7c-19.4-.4-39.5-.7-60-.9l.1-4.8c0-4.4.1-8.8.1-13.2h-1.1l-.6,13.2-.2,4.8c-21.5-.2-43.5-.4-65.9-.4l-.2-13.1c-.1-1.9-.1-3.7-.1-5.5h-1.4l-.1,5.6-.1,13.1h-3.7q-30.75,0-62,.3l-.7-11.8-.5-7.3h-1.4l.2,7.3.4,11.8c-22.7.2-45.5.5-68.1,1l-.3-7.9c-.2-3.9-.3-7.7-.5-11.6h-1.2l.1,11.6.1,7.9c-21.1.4-42.1.9-62.7,1.5-.2-2.7-.4-5.4-.7-8.1-.4-3.9-.7-7.8-1.1-11.8h-1.2l1.1,19.8c-21.6.6-42.9,1.4-63.6,2.3-.2-3.1-.5-6.1-.8-9.2-.3-3.7-.7-7.4-1-11h-1.2l1.1,20.3c-20.9.9-41.3,1.9-60.9,3.1l-.4-3.3L300,6.7c16.5-.8,33.5-1.5,50.9-2.1C424.81,1.9,505.51.4,583,.4c172.7,0,329.9,7.4,362.6,24.9a2.18,2.18,0,0,1,.8.5,26.18,26.18,0,0,1,5.9,3.9",
    style: {
      fill: "#6e9895"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path214",
    d: "M112.41,49.1l-4-27c.2,0,.4-.1.6-.1,1.5,7.4,2.9,14.7,4.4,22.1.3,1.5.6,3,.8,4.5-.6.2-1.2.3-1.8.5",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path216",
    d: "M172.41,38.4l-.5-5c-.6-6.2-1.2-12.4-1.8-18.5.3,0,.6-.1.8-.1.9,6.1,1.7,12.3,2.6,18.4l.7,5c-.5.1-1.2.1-1.8.2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path218",
    d: "M234.11,32v-.3c-.4-7.2-.9-14.4-1.4-21.7h.7c.8,7.2,1.5,14.4,2.3,21.5v.3a7,7,0,0,1-1.6.2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path220",
    d: "M300.51,27.3l-.3-3.3-1.4-17.6a2.77,2.77,0,0,0,.9-.1l2.1,17.5.4,3.3a4.68,4.68,0,0,1-1.7.2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path222",
    d: "M363.21,24.2l-1.1-20.3h1.2c.3,3.7.7,7.3,1,11,.3,3.1.5,6.1.8,9.2a11.48,11.48,0,0,0-1.9.1",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path224",
    d: "M428.61,21.8,427.51,2h1.2c.4,3.9.7,7.9,1.1,11.8.2,2.7.4,5.4.7,8.1a12.1,12.1,0,0,0-1.9-.1",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path226",
    d: "M493.21,20.2l-.1-7.9L493,.7h1.2c.2,3.9.3,7.7.5,11.6l.3,7.9h-1.8",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path228",
    d: "M563.21,19.2l-.4-11.8-.2-7.3H564l.5,7.3.7,11.8h-2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path230",
    d: "M632.91,18.9h-2L631,5.8l.1-5.6h1.4c0,1.9.1,3.7.1,5.5l.3,13.2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path232",
    d: "M700.61,19.3h-1.8l.2-4.8.6-13.2h1.1c0,4.4-.1,8.8-.1,13.2v4.8",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path234",
    d: "M762.41,20.3h-1.8l.2-4.7.6-12.3h1.2c0,4.1-.1,8.2-.1,12.3l-.1,4.7",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path236",
    d: "M831.31,22.3a12.75,12.75,0,0,1-1.9-.1l-.1-6.8-.2-8.6c.4,0,.9.1,1.3.1l.6,8.4.3,7",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path238",
    d: "M910.41,26.2c-.4,0-.9-.1-1.3-.1l.4-10.2v-.7a2.77,2.77,0,0,0,.9.1V26.2",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path240",
    d: "M668.71,252.4a3,3,0,0,1,.2,1c-.1-.4-.1-.7-.2-1m282.9-16.1c-4.8-6.8,6.3-31.1-4.6-31.1s-289.2,10.4-289.2,10.4c-14.5-1.8-272.4-10.6-279.9-5.4a43.25,43.25,0,0,0-4.6,4.1,25.6,25.6,0,0,1,3-2.8c8.7-7.4-307.7,0-307.7,0-5.8,3.3,7.2,21.8,4.1,27.8-6.2,11.7,18.8,70.6,24.4,72.9,26.5,10.6,148.9,8.9,217,7.2,25.3-.6,43.1-1.3,45.6-1.3.2,0,.3-.3.4-.9a14,14,0,0,0,1.7.9c18,7.2,253.2,14.2,298.2,1.1h0c21.7,12.9,265.8,6,272-16.9,6-22.9,24.4-59.2,19.6-66",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path242",
    d: "M394.11,318.1h-32.4a14,14,0,0,1-1.7-.9c0,.5-.2.9-.4.9h0c.5-9.5,0-18.9-.1-28.1,0-1,0-2.1-.1-3.1,31.2,16.3,81.1,23.2,131.9,23.2,69.4,0,140.5-12.9,168.5-32.3l-.3,15.3c-.1,7.5-.1,15.1.2,22.7q-67.5,1.35-152.3,2c-39.7.2-77.6.3-113.3.3",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path244",
    d: "M660.81,315.7a186.44,186.44,0,0,0,4.2-22.3c.7-5.5,1.3-11.1,1.7-16.7,21.1,13.5,62.5,19.5,108.3,19.5,56.3,0,119-9.2,158-25a254.2,254.2,0,0,1-9.1,24.1,15.89,15.89,0,0,1-12.5,9.3c-32,4.1-115.4,8.4-250.6,11.1",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path246",
    d: "M359.61,318.1c-120.7-.3-211.8-2.3-248.7-4.7a16,16,0,0,1-13.8-10.2c-2.8-7.2-6-16.6-9.5-28,40.7,14.7,110.9,26.6,172.2,26.6,37.5,0,71.6-4.5,93.6-15.5.2,1.4.3,2.8.5,4.2a246,246,0,0,0,5.7,27.6",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path248",
    d: "M373.41,214.3l.9-.9h0a3.82,3.82,0,0,0-.9.9",
    style: {
      fill: "#4d7270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path250",
    d: "M374.31,213.3h0c.7-.7,1.4-1.4,2-1.9h0l-.3.3c-.5.5-1.1,1-1.7,1.6",
    style: {
      fill: "#496865"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path252",
    d: "M359.41,286.8c-1.2-.6-2.4-1.3-3.5-1.9a19.65,19.65,0,0,1-2.5,1.3,151.13,151.13,0,0,1-.8-24.3c.6-9.5,2.2-19.2,5.8-28.3a53.28,53.28,0,0,1,7.2-12.7,39.1,39.1,0,0,1,10.7-9.6c-.7.6-1.3,1.2-2,1.9l-.9.9.9-.9c.6-.6,1.2-1.1,1.7-1.6a59.24,59.24,0,0,0-12.3,23.7,126.6,126.6,0,0,0-4,26.9c-.4,8.2-.4,16.4-.3,24.6",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path254",
    d: "M359.61,318.1h0a234.5,234.5,0,0,1-5.7-27.7c-.2-1.4-.4-2.8-.5-4.2.9-.4,1.7-.9,2.5-1.3a39,39,0,0,0,3.5,1.9c0,1,0,2.1.1,3.1.1,9.3.6,18.7.1,28.2",
    style: {
      fill: "#4d7270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path256",
    d: "M657.81,215.6h0",
    style: {
      fill: "#4d7270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path258",
    d: "M659.81,277.7c.1-3.6.2-7.1.3-10.7.2-8.6.5-17.3.4-25.8,0-4.3-.1-8.6-.4-12.9a43.05,43.05,0,0,0-2.3-12.7h0a22.44,22.44,0,0,1,3.5,5.7,52.45,52.45,0,0,1,2.2,6.3,84.07,84.07,0,0,1,2.5,13.1,179.42,179.42,0,0,1,1.1,26.4c-.1,3.2-.2,6.3-.4,9.5-1-.7-2-1.3-3-2a40.84,40.84,0,0,1-3.9,3.1",
    style: {
      fill: "#577d7a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path260",
    d: "M659.71,315.7c-.3-7.6-.3-15.2-.2-22.7l.3-15.3a42.38,42.38,0,0,0,4-3.1,22.34,22.34,0,0,0,3,2c-.4,5.6-.9,11.1-1.7,16.7a190.26,190.26,0,0,1-4.2,22.3,5.74,5.74,0,0,1-1.2.1",
    style: {
      fill: "#4d7270"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path262",
    d: "M344.31,259a34.71,34.71,0,0,0-7.6-2.8,74.27,74.27,0,0,0-7.9-1.7c-5.3-.9-10.7-1.6-16.1-2.1s-10.8-1-16.2-1.4-10.8-.7-16.2-.9c-10.8-.5-21.7-.9-32.5-1.1s-21.7-.5-32.6-.5c-5.3-.1-10.7-.1-16-.1-5.5,0-11,0-16.6.1h-.4c-10.7,0-21.5.2-32.2.4-10.9.2-21.7.5-32.6,1s-21.7,1.1-32.5,2.6c2.6-.8,5.3-1.4,7.9-2s5.4-1.1,8-1.6c5.4-1,10.8-1.7,16.2-2.4,10.8-1.3,21.7-2.4,32.6-3.1s21.8-1.2,32.7-1.6c10.1-.3,20.2-.4,30.3-.4h2.5q16.35.15,32.7.9c10.9.6,21.8,1.2,32.7,2.3s21.7,2.4,32.5,4.4a142.89,142.89,0,0,1,16,3.7c5.4,1.4,10.8,3.1,15.3,6.3",
    style: {
      fill: "#769d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path264",
    d: "M648.81,261.5l-4.3-1.2-4.3-1c-1.4-.3-2.9-.6-4.4-.9s-2.9-.6-4.4-.8c-5.8-1-11.7-1.8-17.6-2.5-11.8-1.5-23.6-2.5-35.4-3.4s-23.7-1.7-35.5-2.2-23.7-1-35.5-1.2q-12.75-.3-25.5-.3c-3.4,0-6.7,0-10.1.1-11.8,0-23.7.5-35.5,1s-23.6,1.4-35.4,2.9a190,190,0,0,0-34.8,7c10.9-5,22.6-8,34.3-10.4a356.58,356.58,0,0,1,35.5-5c11.9-1.2,23.8-1.7,35.8-2.2,6.4-.2,12.7-.2,19.1-.2,5.6,0,11.2.1,16.7.1,11.9.3,23.9.8,35.8,1.6s23.8,1.9,35.6,3.4,23.7,3.2,35.4,5.5c2.9.6,5.9,1.2,8.8,1.9l4.4,1,4.3,1.1a125.66,125.66,0,0,1,17,5.7",
    style: {
      fill: "#769d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path266",
    d: "M673.11,260.3a70.82,70.82,0,0,1,15.7-5.3c5.4-1.3,10.8-2.3,16.2-3.3,10.9-1.9,21.8-3.3,32.8-4.5s22-2.1,33-2.9,22-1.3,33-1.8c11-.3,22-.6,33.1-.7s22.1.1,33.1.6,22.1,1.1,33.1,2.3c5.5.6,11,1.3,16.4,2.3q4.05.75,8.1,1.8a28.9,28.9,0,0,1,7.7,3.1,27.17,27.17,0,0,0-7.9-2.1q-4-.6-8.1-.9c-5.5-.4-10.9-.7-16.4-.8-6.7-.2-13.3-.3-20-.3-4.3,0-8.6,0-12.9.1-11,.2-21.9.3-32.9.6s-21.9.6-32.9,1-21.9.8-32.9,1.4c-11,.4-21.9,1.1-32.9,1.7s-21.9,1.4-32.8,2.5c-5.5.5-10.9,1.1-16.3,1.8-2.7.4-5.4.8-8.1,1.3a68.58,68.58,0,0,0-8.1,2.1",
    style: {
      fill: "#769d9b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path268",
    d: "M100.21,346.4c-8.9,28.3-22.6,89.5-10.7,89.7,19.1.3,39.2-89.7,39.2-89.7h-28.5",
    style: {
      fill: "#d9a476"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path270",
    d: "M113,400.8c-4.4-11.1-11.5-21.3-20.6-25.6,1.5-6.3,3-12.3,4.6-17.8,6.5.8,15.6,1.5,28.5,2.1-2.8,10.9-7.2,26.8-12.5,41.3",
    style: {
      fill: "#cf9263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path272",
    d: "M914.11,346.4c8.9,28.3,22.6,89.5,10.7,89.7-19.1.3-39.2-89.7-39.2-89.7h28.5",
    style: {
      fill: "#d9a476"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path274",
    d: "M915.51,350.9h0m-.1-.1h0m0-.2h0m-.1-.1h0",
    style: {
      fill: "#f4e4d6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path276",
    d: "M926.41,397.1c-7.3-12.4-15.3-20.5-22.1-20.5-3.4,0-6.4,2-9,6.5-3.7-12.1-6.6-23.5-8.3-30.2,11.2-.8,20.5-1.7,28.2-2.5v.4h0v.1h0a382.07,382.07,0,0,1,11.2,46.2",
    style: {
      fill: "#cf9263"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path278",
    d: "M924,302.3h0M400,363.5c-62.6,0-127.2-.4-176.5-1.2-137.6-2.2-138.4-5.9-146.2-10.5-10.5-6.2-38.2-10.9-77-211.4a16.33,16.33,0,0,1,6-16.2c11.2-8.3,23.2-10.5,36.2-6.3a16.19,16.19,0,0,1,10.6,12.4c15.8,81.5,32.8,144.7,44,172.9a16.11,16.11,0,0,0,13.8,10.2c50.8,3.4,204.2,5.8,396.4,4.3,227-1.7,361.3-7.6,404-13.1a15.89,15.89,0,0,0,12.5-9.3c12.9-28.7,31.7-99.7,44.9-163.3a19.92,19.92,0,0,1,13.7-15c14.1-4.1,26.1-2.3,35.5,6.4a19.63,19.63,0,0,1,5.7,18.4c-3.3,15.6-10.5,49.2-19.6,84.6-23.6,91.4-33.3,102-45.7,112.1-8.9,7.2-16.6,13.4-157.4,18.8-74,2.8-181.2,4.8-292,5.7-38.3.3-71.5.5-108.9.5",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path280",
    d: "M97,357.4c-14-1.7-16.1-3.6-19.7-5.7h0c3.6,2.1,5.7,4,19.7,5.7h0",
    style: {
      fill: "#dfe8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path282",
    d: "M77.31,351.7h0m-.1,0h0m0-.1h0m-.1,0h0M955,341.1c1.3-.8,2.3-1.7,3.4-2.5,12.4-10.1,22.2-20.7,45.7-112.1,9.2-35.5,16.4-69,19.6-84.6v0c-3.3,15.6-10.5,49.2-19.6,84.6-23.6,91.4-33.3,102-45.7,112.1-1.1.8-2.2,1.6-3.4,2.5",
    style: {
      fill: "#dfe8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path284",
    d: "M400,363.5c-62.6,0-127.2-.4-176.5-1.2-46.4-.8-77.2-1.7-98-2.7-13-.7-22-1.4-28.5-2.1h0c-14-1.7-16.1-3.6-19.7-5.7h-.1c-3.7-2.1-9.5-4.3-17.2-14.7,51.9,5.8,193.8,9.2,349.2,9.2,239.2,0,510.5-7.9,534.8-26.9,31.1-24.2,58.6-126.3,74.9-194.8a19.83,19.83,0,0,1,4.8,17.3v.1c-3.3,15.6-10.5,49.2-19.6,84.6-23.6,91.4-33.3,102-45.7,112.1a29.85,29.85,0,0,1-3.4,2.5c-9.2,6.1-30,11.5-154,16.3-65.1,2.5-155.7,4.3-251.9,5.3-13.3.1-26.6.3-40,.4-38.5.1-71.7.3-109.1.3",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path286",
    d: "M49.71,122.8a15.21,15.21,0,0,0-7.2-5,15.71,15.71,0,0,1,7.2,5h0",
    style: {
      fill: "#dfe8e8"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path288",
    d: "M49.71,122.8h0",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path290",
    d: "M51,124.8a14.29,14.29,0,0,0-1.4-2h0a9,9,0,0,1,1.4,2h0",
    style: {
      fill: "#608a87"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path292",
    d: "M110.91,313.3c-43.2-1.9-67.9-172.1-68.4-195.6h0a15.21,15.21,0,0,1,7.2,5h0a14.29,14.29,0,0,1,1.4,2c3.2,16.9,8.3,36.5,10.6,56.7v1.9h0v.3h0c1.2,11,3.9,18.6,7.7,23.7,10.3,43.8,20.2,77.3,27.5,95.8a16.51,16.51,0,0,0,14,10.2",
    style: {
      fill: "#527f7c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M626.91,39.8c16.6-10.6,56.9-1.8,97.5.9,16,1.1,32.9.1,47.6-.9,22.5-1.5,40-3,42,2.9,3.3,9.7-10.2,72.1-8.5,96.5s9.9,65.1,8.7,72.3-88.3-3.4-102.3-3.4-91.4,11.6-92-1.1,11.3-51.5,11.7-69.6-9.5-94.5-4.7-97.6",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g296"
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#54d03cf1-f171-4131-add4-8c191b53a0d5)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    id: "g298"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path304",
    d: "M650.11,212.8h0c1.9-.1,3.9-.1,5.8-.2h0c-2,.1-3.9.2-5.8.2m1.2-9.5c-.8-7.7-2.7-19.2-4.4-31.3a3.19,3.19,0,0,1,.6.7l-.1-2.1-.5,1c-.4-2.5,1-16,.9-18.7l-.1.7a33.8,33.8,0,0,1,.6-6l-.1,1.5c.6-.5.8-1.7,1-3.2l-.3.9c-.2-1.7.4-2.9.7-5.4l-.3.9c0-.5.2-1.2.3-2,0,.3,0,.4.1.4s.5-1.3.7-1.6a.31.31,0,0,1-.2.1c-.3,0,0-1.9.1-2.6.4-.3.1-2.3.5-2.4,0-.3,0-.4-.1-.4s-.2.2-.3.3a10.07,10.07,0,0,0,.3-2.5h.1l8.6,1.6c1.9.4,3.9.7,5.8,1-1.4,10.2-4.3,30.3-5.3,40.3v-.3c-.6,4.4-1.8,17.5-2.8,27.6a38.29,38.29,0,0,1-5.8,1.5m-1-68.8v0m.8-7.9c.3-1,.2.2.2-3.8l.3-.6-.4-.4c.9-.9.5-3.1,1.3-3.5-.3-.6.1-1.1-.1-2.4-.5.5-.3,2-.7,2.6,0-2.3.3-8.7.2-15.1s-.6-12.8-.8-15c.1.3.1.5.2.5s.2-.2.2-.6l-.3-1.7a1.34,1.34,0,0,0-.1.5L651,87c-.2-.7,0-1.6-.5-1.9h0c.1,0,.2-.3.2-.6v-.6h0c-.5-.8,0-3.9-.9-4.7-.5-2.4.4-.6,0-3.2l-.6-.1v-.2c1.3-9.7,2.4-18.4,2.7-24.6,2.4.2,5.2.4,8.3.7.1,1.5-.3,1.6.5,4.2v-.5c1,3.4,3.3,20.4,3.8,23.4l-.2-.3c.6,2.8.8,6.4,1.5,9.2.1,2.7.6,9.9.7,17.2v5.4c-.1,1.8-.1,3.5-.1,5.1,0,3.2-.3,5.8-.3,7.4a19.71,19.71,0,0,0-.1,2.1h-.2c-2.1,0-4.1.1-6.2.2a62.75,62.75,0,0,0-8.5,1.4m-5-91.7c2.1-.1,4.3-.2,6.6-.2h0c-2.3,0-4.5.1-6.6.2",
    style: {
      fill: "#cacdd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path306",
    d: "M687.31,210.1h0c5-.5,9.6-.9,13.5-1.3h0c-1.3.1-2.8.3-4.2.4l-2.9.3c-2,.2-4.2.4-6.4.6m.2-11.2c.6-5.2,1.6-23.6,1.8-27.5.1.2,1,.9,1.1,1.1l-.2-1.9-.5,1c-.5-2.2-.1-14.5-.4-16.9l-.1.7a33,33,0,0,1,.1-5.4l.1,1.4c.6-.5.6-1.6.6-2.9l-.3.8c-.4-1.5.1-2.7.2-4.9l-.2.8a5.74,5.74,0,0,1,.1-1.8.58.58,0,0,0,.1.4c.1,0,.3-1.2.6-1.5-.1.1-.1.1-.2.1-.3,0-.2-1.7-.2-2.3.4-.3-.1-2.1.3-2.2v-.1l3.7.3c2.9.2,5.9.3,8.9.4h1.8c-.3,9.8-1.5,27-1.9,35.6v-.2c-.2,3.9-.8,15.3-1.3,24.3-4.8.2-9.5.5-14.1.7m1.8-27.5h0M690,138h0m0-.1v-.1h0v.1m15.3-4a3.7,3.7,0,0,0-1.1-.5,69.12,69.12,0,0,0-8.5-3.5c-1.9-.6-3.7-1.2-5.6-1.7a3.75,3.75,0,0,0-.1-1l.3-.6-.4-.3c.8-.9.3-3,1-3.4-.3-.5.1-1.1-.2-2.2-.5.5-.3,1.9-.7,2.4,0-4.4.3-24.1.3-28.2,0,.3.1.4.2.4s.2-.2.3-.5l-.2-1.6c-.1.1-.1.4-.2.4l-.1-.1c-.1-.7.2-1.5-.3-1.8h0c.1,0,.2-.3.2-.5a1.21,1.21,0,0,1,.1-.5h0c-.4-.8.4-3.6-.4-4.5-.2-2.2.5-.5.4-2.9l-.6-.1V81.1c0-1.2-.1-2.8-.1-4.4a49.8,49.8,0,0,0-.4-6h0a2.46,2.46,0,0,0,.4-1c-.2-2.3-.3-4.3-.5-6.8a.44.44,0,0,0,.1.3l.1-.1c-.2-3-.3-6-.4-8.9,4.4.3,9,.7,13.7,1,.3,1.6.5,3.1.6,3.9h-.1c.1.9.5,3,1,3h.1c-.1,2.2-.7,1.8-.2,4.6l.1-.4c.4,3.2.4,18.5.6,21.2l-.1-.2c.4,2.5.1,5.7.6,8.3-.1,4.8-.5,25.5-.4,31,0,4.8.4.4.2,5.1,0,.4,0,.7.1.7s.2-.2.2-.5a13.33,13.33,0,0,1,0,2m-3.4-95.2c-4.4-.5-8.8-.9-13-1.4h0c4.2.5,8.6,1,13,1.4h0",
    style: {
      fill: "#cacdd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path308",
    d: "M745,198.2l-13.7-.3c.1-.8.1-1.6.2-2.3a4.92,4.92,0,0,0-.5-2.9l.3.1.2-1.8c-.3.3-.8-.1-1,.7-.2-.1,0-.6,0-1.3,0,.2.2.5.3.5a.1.1,0,0,0,.1-.1c.1-1.4-.2-.5-.3-2.2,0,0,.2.5.4.5s.2-.2.3-.7c.5-3.4,1.3-22.4,1.4-26.3.1.2,1,.8,1.1,1l-.2-1.7-.4.9c-.6-2-.5-13.4-.9-15.6v.6a27,27,0,0,1-.1-5l.1,1.3c.5-.5.5-1.5.5-2.7l-.2.8c-.4-1.4,0-2.5,0-4.5l-.2.8a9.58,9.58,0,0,1,0-1.7c0,.3.1.3.1.3s.3-1.1.5-1.4c-.1.1-.1.1-.2.1-.3,0-.2-1.6-.3-2.1.4-.3-.2-1.9.2-2a.44.44,0,0,0-.1-.3c-.1,0-.2.2-.2.3.2-1.3-.3-2.5-.3-4.9.2-4.3.4-.5,0-5.4l.3-.5-.4-.3c.8-.8.2-2.8,1-3.2-.3-.5.1-1-.2-2.1-.5.5-.3,1.8-.7,2.3-.1-4.1.5-22.6.6-26.4,0,.3.1.4.2.4s.2-.2.3-.5l-.2-1.5c-.1.1-.1.4-.2.4l-.1-.1c-.1-.6.2-1.4-.2-1.7h0c.1,0,.2-.2.2-.5a2,2,0,0,1,.1-.5h0c-.4-.7.4-3.4-.4-4.2-.2-2.1.5-.5.5-2.7l-.6-.1V77.8c0-1.1,0-2.6-.1-4.1-.1-2.8-.2-5.6-.4-5.6h0a1.87,1.87,0,0,0,.4-.9c-.2-2.1-.2-4.1-.4-6.3a.44.44,0,0,0,.1.3l.1-.1c-.1-1.4-.1-2.9-.2-4.3,3.5.1,7,.1,10.4.1h3.7c0,.2.1.4.1.6h-.1c.1.8.4,2.8,1,2.8h.1c-.1,2-.7,1.7-.3,4.3l.1-.4c.3,3,.1,17.3.3,19.8l-.1-.2c.3,2.3,0,5.4.5,7.8-.2,4.5-.8,23.8-.6,28.8.1,4.4.4.3.3,4.7a2.18,2.18,0,0,0,.1.6c.1,0,.2-.1.2-.5a25,25,0,0,1-.5,4.7c.3,8.8-.4,26.3-.7,34.8v-.2c-.2,5.6-1,27.6-1.5,33.1l.2.6m-12.2-36h0m-.5-31h0c.1-.1.1,0,0,0m7.1-90h0m0,0c-2.6,0-5.3,0-7.9-.1h0c2.6.1,5.3.1,7.9.1",
    style: {
      fill: "#cacdd0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path310",
    d: "M793.41,200.8c-2.3-.2-7.2-.6-13.8-1-.4-5.9-.7-11.3-.8-13.3.1.3,1.1.8,1.2,1.1l-.4-2.1-.4,1.2c-.8-2.5-1.5-16.6-2.1-19.3v.8a39.55,39.55,0,0,1-.4-6.2l.2,1.6c.5-.6.5-1.9.4-3.4l-.2,1c-.5-1.7-.1-3.1-.2-5.7l-.1,1a13.28,13.28,0,0,1,0-2,1.58,1.58,0,0,1,.1.4c.1,0,.2-1.4.4-1.8-.1.1-.1.2-.2.2-.3,0-.3-2-.3-2.6.4-.4-.3-2.4.1-2.5,0-.3-.1-.4-.2-.4s-.2.2-.2.4c.2-1.7-.4-3.1-.4-6.1.2-5.3.3-.7,0-6.7l.3-.7-.4-.4c.8-1,.2-3.5,1-4-.3-.6.1-1.2-.1-2.6-.5.6-.4,2.2-.7,2.9-.1-2.6.2-9.6.5-16.6s.9-13.9,1-16.3c0,.4.1.5.1.5s.2-.2.3-.6l-.1-1.8a4.71,4.71,0,0,0-.2.5l-.1-.1c-.1-.8.3-1.7-.1-2.1h0c.1,0,.2-.3.3-.6a2.14,2.14,0,0,0,.1-.6h0c-.4-.9.7-4.2,0-5.2,0-2.6.6-.6.7-3.4l-.6-.2c0-.1.1-1,.2-2.4s.2-3.3.3-5.1c.3-3.6.5-7.1.4-7.1h0a3.19,3.19,0,0,0,.6-1.1c.1-2.6.3-5.1.5-8,0,.2,0,.4.1.4l.1-.1c.2-2,.4-3.9.7-5.9A128.29,128.29,0,0,0,795,52c-.1,2.3,0,5.1-.1,6.4l-.1-.1c-.1,1,0,3.4.5,3.4h.1c-.4,2.4-.9,1.9-.9,5.1l.1-.5c-.1,1.8-.6,7-1.1,12.1s-.8,10.3-.8,11.8l-.1-.3c.1,2.9-.5,6.5-.1,9.4-.6,5.4-1.8,28.9-1.5,35,.1,5.3.4.4.3,5.7,0,.4.1.7.2.7s.2-.2.2-.6a54.59,54.59,0,0,1-.4,5.7c.4,10.7.6,32,1.3,42.3l-.1-.3c.2,2.2.5,7.2.9,13m-13.3-13.2h0m-1.2-1.1h0m-2.3-38.5v0",
    style: {
      fill: "#cacdd0"
    }
  })))), /*#__PURE__*/React.createElement("path", {
    id: "path312",
    d: "M814,42.7c0-.1-.1-.1-.1-.2s.1.1.1.2m-74.6-1.5h0m0,0c6.8,0,13.6-.3,20.2-.6h0c-6.5.3-13.3.6-20.2.6m-13.8-.4h0m36.4-.3h0c2.6-.1,5.1-.3,7.6-.5-2.5.2-5.1.3-7.6.5m7.8-.5h0m.8-.1h0m.8,0h0m.6-.1h0m1.5-.1c9.5-.6,18.1-1.3,24.9-1.3-6.8.1-15.4.7-24.9,1.3M629,38.7a8.65,8.65,0,0,1,1.7-.7h0a5.09,5.09,0,0,0-1.7.7h0m169.5-.2h0M633.21,37h0a58.93,58.93,0,0,1,12.9-2.1,57.93,57.93,0,0,0-12.9,2.1",
    style: {
      fill: "#699491"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path314",
    d: "M630.71,37.9h0c.8-.3,1.6-.6,2.5-.9h0c-.9.3-1.7.6-2.5.9",
    style: {
      fill: "#638683"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path316",
    d: "M746.11,56.7c-.2-1.4-.7-3.8-.9-5.7l.3.1h0a51.12,51.12,0,0,1-.6-6.3V41.1c-1.8,0-3.6.1-5.5.1h0c6.8,0,13.6-.3,20.2-.6.8,0,1.6-.1,2.3-.1,2.6-.1,5.1-.3,7.6-.5h2.9a4.1,4.1,0,0,0,1.1-.1c9.5-.6,18.1-1.3,24.9-1.3h.1c8.5,0,14.2.9,15.5,4,0,.1.1.1.1.2h0c-4.6,3.8-11.2,6.7-19,8.8a4.87,4.87,0,0,1,.1-1.2l.3.1h0c-.2-2.2.6-6,.8-7.5q.3-1.95.9-4.5c-4.1.1-8.7.3-13.7.6-.4,2.4-.8,4.7-1.2,7.1-.4,2.7-.7,5.4-1.1,8.1a258.13,258.13,0,0,1-35.1,2.4m-14.2-.1c-9.9-.2-19.8-.7-29.2-1.3-.1-.9-.3-1.9-.4-2.7l.3.1h0A42.55,42.55,0,0,1,702,46c0-1.9,0-4.5-.1-7.2,7.4.8,14.9,1.5,22.5,2a3.4,3.4,0,0,1,1,.1h.1l5.9.3c.3,5.1.4,10.2.5,15.4M689,54.3l-6.8-.6c-8.3-.7-15.7-1.4-22-1.9a3.08,3.08,0,0,0-.1-.9H660c-.5,0-1.2-2.2-1.5-3.1h.1c-.4-1.5-1.6-4.7-2.2-7.1h.3a54.32,54.32,0,0,1-1.6-6.1c10,.2,21.5,1.3,33.8,2.6v.4c.1,1.3-.5.1-.4,1.6.2,5.2.3,10.1.5,15.1m-46.7-15.6c-1.6-.1-3.4-.2-5.4-.2h-1c-2.1,0-4.4.1-6.8.2a8.65,8.65,0,0,1,1.7-.7c.8-.3,1.6-.6,2.5-.9a58.93,58.93,0,0,1,12.9-2.1h0c-1.6.1-3.1.2-4.5.4a19.09,19.09,0,0,0,.6,3.3",
    style: {
      fill: "#494d4c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path318",
    d: "M660.21,51.8c-3.1-.3-5.9-.5-8.3-.7.2-3.9.1-6.9-.4-8.4-.8-2.3-4.1-3.5-9.1-4-.2-1.1-.5-2.3-.7-3.4,1.4-.2,2.9-.3,4.5-.4,2.1-.1,4.3-.2,6.6-.2h2.4a54.32,54.32,0,0,0,1.6,6.1h-.3c.6,2.4,1.8,5.6,2.2,7.1h-.1c.2.9,1,3.1,1.5,3.1h.1a1.1,1.1,0,0,0,0,.8",
    style: {
      fill: "#ced1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path320",
    d: "M702.71,55.3c-4.7-.3-9.3-.7-13.7-1-.2-5-.3-9.9-.5-14.9-.1-1.5.5-.3.4-1.6v-.4c4.3.5,8.6.9,13,1.4.1,2.7.1,5.3.1,7.2a59.18,59.18,0,0,0,.6,6.7l-.3-.1c.1.8.3,1.8.4,2.7",
    style: {
      fill: "#ced1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path322",
    d: "M742.41,56.7c-3.5,0-7,0-10.4-.1-.2-5.2-.2-10.4-.4-15.5,2.6.1,5.3.1,7.9.1h0c1.8,0,3.6,0,5.5-.1v3.7a53,53,0,0,0,.6,6.3l-.3-.1c.2,1.8.7,4.2.9,5.7h-3.8",
    style: {
      fill: "#ced1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path324",
    d: "M781.11,54.4c.3-2.7.7-5.4,1.1-8.1.4-2.4.8-4.8,1.2-7.1,5-.3,9.7-.5,13.7-.6-.3,1.7-.7,3.2-.9,4.5a52.3,52.3,0,0,0-.8,7.5l-.3-.1c0,.4-.1.8-.1,1.2-4.3,1-9,1.9-13.9,2.7",
    style: {
      fill: "#ced1d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path326",
    d: "M805.51,139.2v0m0-.1v0m0-.1v0m0-.2h0m0-.1h0m0-.2h0m0-.1h0m0-.2h0m1.5-26.7v0m0-.2v-.2c.1.1.1.1,0,.2m.1-.2c.8-6.9,1.7-14.1,2.7-21.2h0c-1,7.1-2,14.3-2.7,21.2",
    style: {
      fill: "#486c6a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path328",
    d: "M759.41,211.9l-3.2-.3h0l3.2.3h0m-5.9-.5c-18.8-1.6-36-3.3-41.6-3.3h0c3.2,0,10,.5,18.8,1.3h0c4.2.4,8.8.8,13.6,1.2h0c3,.2,6.1.5,9.2.8h0",
    style: {
      fill: "#3f6260"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path330",
    d: "M756.21,211.6c-.9-.1-1.8-.1-2.7-.2h0c.9.1,1.8.1,2.7.2h0",
    style: {
      fill: "#3a5856"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path332",
    d: "M799.31,214c-10.6,0-25.4-1-40-2.2h0c7.2.6,14.5,1.1,21.2,1.5h0c5,.3,9.7.5,14,.6h0c1.7.1,3.3.1,4.8.1h0m.1,0c8.7,0,14.4-.7,14.9-2.5-.5,1.9-6.3,2.5-14.9,2.5",
    style: {
      fill: "#486c6a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path334",
    d: "M799.31,214c-1.5,0-3.1,0-4.8-.1-.2-2.1-.4-4.3-.6-6.5s-.4-4.6-.6-6.7c.4,0,.7.1.9.1h.1c9.7,0,.8-89.6,15.3-111-1,7.1-1.9,14.4-2.7,21.2h0v.4c-1.2,10.4-1.9,19.9-1.6,26.8h0v.1h0v.1h0v.4h0v.1h0v.1h0v.1h0c1.5,22.7,8.8,59.4,8.8,70.3a11.52,11.52,0,0,1-.1,2h0c-.2,2-6,2.6-14.7,2.6h0m-18.7-.6c-6.8-.4-14-.9-21.2-1.5l-3.2-.3c-.9-.1-1.8-.1-2.7-.2-3.1-.3-6.2-.5-9.2-.8.2-1.8-.3-3,.1-4.8l.1.3c.3-.8.1-2.3.4-3.7l-.2.4c-.1,0-.1-.1-.1-.5a27.7,27.7,0,0,1,.6-3.8v-.2c13.7.4,25.7,1,34.6,1.6.2,4.6.5,9.6.8,13.5m-124.7-.8c.2-2.3.6-6,1-10.3,9.5-1.6,19.9-2.6,30.6-3.3,0,.3-.1.6-.1.8-.1.5-.2.7-.3.7s-.3-.5-.4-.5c0,1.8.4.8.2,2.3a.1.1,0,0,1-.1.1c-.1,0-.2-.3-.2-.5,0,.7-.2,1.3,0,1.4.2-.8.7-.4,1-.8l-.2,2-.3-.1a5.55,5.55,0,0,1,.5,3.1,24.52,24.52,0,0,0-.2,2.7c-9.9.9-21.1,1.9-31.5,2.4m74.8-3.2c-8.8-.8-15.6-1.3-18.8-1.3h0c-2.3,0-6.1.3-11.1.7.2-2.1.4-6.1.6-10.6,7.4-.3,14.9-.4,22.1-.4h7.7c-.2,2.3-.3,4.8-.5,7-.2-.1-.2-.7-.3-1.4a3.4,3.4,0,0,1-.2,1.4l.1-.1c.1,0,.1.2.1.5v.5l.1-.1a9.76,9.76,0,0,1,.2,3.8",
    style: {
      fill: "#2d3130"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path336",
    d: "M650.11,212.8q1.35-.45,1.5-1.2h0a11.52,11.52,0,0,0,.1-2c0-1.6-.2-3.7-.4-6.2,1.8-.4,3.7-.7,5.6-1-.4,4.3-.8,8-1,10.3-2,0-3.9,0-5.8.1",
    style: {
      fill: "#9b9ea1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path338",
    d: "M687.31,210.1a24.52,24.52,0,0,0,.2-2.7,5.55,5.55,0,0,0-.5-3.1l.3.1.2-2c-.3.3-.8-.1-1,.8-.2-.1,0-.7,0-1.4,0,.2.1.5.2.5a.1.1,0,0,0,.1-.1c.1-1.5-.2-.5-.2-2.3,0,0,.2.5.4.5s.2-.2.3-.7c0-.2.1-.5.1-.8,4.6-.3,9.3-.5,14-.7-.2,4.5-.5,8.5-.6,10.6-3.9.4-8.5.9-13.5,1.3",
    style: {
      fill: "#9b9ea1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path340",
    d: "M744.31,210.6c-4.8-.4-9.4-.8-13.6-1.2a11.42,11.42,0,0,0-.1-3.7c0,.1,0,.1-.1.1v-.5c0-.3,0-.5-.1-.5a.1.1,0,0,0-.1.1,3.4,3.4,0,0,0,.2-1.4c.1.7.1,1.3.3,1.4.2-2.3.4-4.7.5-7,4.7,0,9.3.1,13.7.3v.2c-.4,1.1-.2,2.3-.6,3.8,0,.4,0,.5.1.5s.2-.2.2-.4c-.3,1.4-.1,2.9-.4,3.7l-.1-.3c-.3,1.9.2,3.1.1,4.9",
    style: {
      fill: "#9b9ea1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path342",
    d: "M794.61,214c-4.2-.1-9-.3-14-.6-.3-3.9-.6-8.9-.9-13.6,6.6.4,11.4.8,13.8,1,.2,2.2.4,4.5.6,6.7a46.23,46.23,0,0,0,.5,6.5",
    style: {
      fill: "#9b9ea1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path344",
    d: "M712,138.7c-2.5-.2-4.9-.1-7.3-.2V137a14.35,14.35,0,0,0,.5-3.1,24.79,24.79,0,0,1,3.1,1.8,15.23,15.23,0,0,1,3.7,3m-21.6-.8h-.3c.1-.1.1-.2.2-.2s0,0,.1.2m-.4-.1c-4.5-.3-9-.8-13.5-1.4-3.8-.5-7.6-1.1-11.4-1.7h0a36.06,36.06,0,0,0,1.2-5.7q-.15.6-.3.6c-.1,0-.1-.3-.1-.7.6-4.3.1-1.9.1-3.7a93.88,93.88,0,0,1,11.9.8,83.54,83.54,0,0,1,12.1,2.4c.2,3.5.1.5-.2,4.6,0,2.3.5,3.4.2,4.8m-39.5-5.9a49.25,49.25,0,0,0-7.7-1.1v-.9a15.39,15.39,0,0,1,3.1-1.7,39.56,39.56,0,0,1,4.5-1.5c.2-.1.4-.1.6-.2-.1.3-.2,1-.4,2.2-.1,1.4-.1,2.4-.1,3.2",
    style: {
      fill: "#2e3533"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path346",
    d: "M665.11,134.7c-1.9-.3-3.9-.7-5.8-1l-8.6-1.6h-.1c0-.9,0-1.9.1-3.1s.3-1.8.4-2.2a51.1,51.1,0,0,1,8.6-1.3c2.1-.2,4.1-.2,6.2-.2h.2c0,1.8.4-.6-.1,3.7-.1.4,0,.7.1.7s.2-.2.3-.6c-.5,1.6-.7,3.9-1.3,5.6h0",
    style: {
      fill: "#9fabad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path348",
    d: "M704.71,138.5h-1.8c-3-.1-5.9-.2-8.9-.4l-3.7-.3a.44.44,0,0,0-.1-.3c-.1,0-.1.1-.2.2h0c.2-1.4-.2-2.6-.1-5,.3-4.1.4-1.1.2-4.6,1.9.5,3.8,1.1,5.6,1.7a63.23,63.23,0,0,1,8.5,3.5,5.36,5.36,0,0,0,1.1.5,14.35,14.35,0,0,1-.5,3.1,9.15,9.15,0,0,0-.1,1.6",
    style: {
      fill: "#9fabad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path350",
    d: "M464.31,39.8c16.6-10.6,56.9-1.8,97.5.9,16,1.1,32.9.1,47.6-.9,22.5-1.5,40-3,42,2.9,3.3,9.7-10.2,72.1-8.5,96.5s9.9,65.1,8.7,72.3-88.3-3.4-102.3-3.4-91.4,11.6-92-1.1,11.3-51.5,11.7-69.6-9.5-94.5-4.7-97.6",
    style: {
      fill: "#e04d46"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path352",
    d: "M463,49c0-5.2.4-8.5,1.3-9.1,5.9-3.8,14.9-5.1,25.8-5.1h0c-10.9,0-19.9,1.3-25.8,5.1-1,.5-1.3,3.9-1.3,9.1m113.8-7.8c-3.5,0-7.1-.1-10.6-.2h0c3.5.1,7,.2,10.6.2,8.1,0,16.2-.4,23.9-.8-7.7.4-15.8.8-23.9.8m-13.1-.3c-.7,0-1.3-.1-2-.1-23.7-1.6-47.3-5.3-66.2-5.9h0c18.9.7,42.5,4.3,66.2,5.9a12.75,12.75,0,0,1,2,.1h0",
    style: {
      fill: "#6e9895"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path354",
    d: "M495.61,34.8c-.8,0-1.5-.1-2.2-.1h0a15.48,15.48,0,0,0,2.2.1h0",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path356",
    d: "M566.21,41c-.8,0-1.6-.1-2.5-.1h0a20.08,20.08,0,0,1,2.5.1h0",
    style: {
      fill: "#688a88"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path358",
    d: "M636.81,38.5h0",
    style: {
      fill: "#5c5f5e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path360",
    d: "M469,137.4v-1.2c0-1.2,0-2.5-.1-4-.8-19.2-6-63.9-6-83.3,0-5.2.4-8.5,1.3-9.1,5.9-3.8,14.9-5.1,25.8-5.1h3.3a16.2,16.2,0,0,1,2.2.1c18.9.7,42.5,4.3,66.2,5.9.7,0,1.3.1,2,.1a20.08,20.08,0,0,0,2.5.1c3.5.2,7,.2,10.6.2,8.1,0,16.2-.4,23.9-.8l8.7-.6c10.2-.7,19.3-1.3,26.5-1.3h1c8.1.1,13.5,1.1,14.5,4.2-13.2,10.9-41.6,14.1-71.7,14.1-20.8,0-42.3-1.5-60.2-3s-32.1-3-38.2-3a13.47,13.47,0,0,0-2.2.1c-12.5,1.8-3.7,10.9-10.1,86.6",
    style: {
      fill: "#e35f59"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path362",
    d: "M636.71,214h0m-6.5-.1c-18.6-.5-45.2-3.1-63.2-4.6h0c17.9,1.5,44.6,4.1,63.2,4.6h0M564,209.1c-6.8-.6-12.1-1-14.8-1h0c2.7,0,8,.4,14.8,1h0",
    style: {
      fill: "#4f6461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path364",
    d: "M632.61,214a19.27,19.27,0,0,1-2.4-.1h0a19.27,19.27,0,0,0,2.4.1h0",
    style: {
      fill: "#495a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path366",
    d: "M636.71,214c6.3,0,11-.3,13.3-1.2h0c-2.3.9-7,1.2-13.3,1.2",
    style: {
      fill: "#4f6461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path368",
    d: "M650.11,212.8h0",
    style: {
      fill: "#c2a2a2"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path370",
    d: "M642.91,139.2v0m0-.1v0m0-.2h0m.8-21.3v0m.1-.1c.8-8.7,2.1-18.2,3.4-27.6h0c-1.3,9.3-2.6,18.9-3.4,27.6",
    style: {
      fill: "#393230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path372",
    d: "M650.11,212.8q1.35-.45,1.5-1.2c-.1.5-.7.9-1.5,1.2h0",
    style: {
      fill: "#957d7e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path374",
    d: "M636.71,214h-4.1a19.27,19.27,0,0,1-2.4-.1c-18.6-.5-45.2-3.1-63.2-4.6-1-.1-2-.2-2.9-.2-6.8-.6-12.1-1-14.8-1h0c-9.1,0-44.6,4.8-68.7,4.8-7.1,0-13.3-.4-17.5-1.5,20.5-10.8,61.4-13.5,97.9-13.5,35,0,65.9,2.5,70.7,3h.1c9.7,0,.8-89.6,15.3-111-1.3,9.4-2.6,19-3.4,27.6h0v.1a151.75,151.75,0,0,0-.9,21.2v.1h0v.1h0v.1h0c1.5,22.7,8.8,59.4,8.8,70.3a11.52,11.52,0,0,1-.1,2h0q-.15.75-1.5,1.2h0c-2.3,1.1-7,1.4-13.3,1.4h0",
    style: {
      fill: "#d83d37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path376",
    d: "M549.41,138.7c-3.1-.2-6.1-.1-9.1-.2s-5.9-.2-8.9-.4c-5.9-.4-11.7-.9-17.5-1.7s-11.5-1.7-17.3-2.8L488,132a61.64,61.64,0,0,0-8.9-1.2,13.29,13.29,0,0,1,4.1-2.5,39.56,39.56,0,0,1,4.5-1.5,60.75,60.75,0,0,1,9.2-1.5c2.1-.2,4.1-.2,6.2-.2a97.06,97.06,0,0,1,12.1.8,98.47,98.47,0,0,1,17.7,4,63.23,63.23,0,0,1,8.5,3.5,33,33,0,0,1,4.1,2.3,14.49,14.49,0,0,1,3.9,3",
    style: {
      fill: "#d83d37"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path378",
    d: "M69.31,73.1c39-6.9,64.3,131.7,46.3,137.4s-48.9,18.1-53.7-26.8c-5.6-53.4-31.6-103.6,7.4-110.6",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path380",
    d: "M61.91,183.7h0v0h0m0-.4v0m0-.3v-.3c-.1.1,0,.2,0,.3m-.1-.4v0m0-.3v0m-.1-.4v0m0-.4h0",
    style: {
      fill: "#4f6461"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path382",
    d: "M88.91,216.5c-12.7,0-24.2-6.8-27-32.8h0v-.3h0v-1.9c-3.3-28.5-12.1-55.9-13.3-76.1,18.9,52,23.5,97.5,35.8,99.9a38.62,38.62,0,0,0,6.1.5c3.8,0,8.1-.4,12.4-.8s8.6-.8,12.6-.8c1.6,0,3.2.1,4.7.2-1,3.4-2.4,5.6-4.4,6.2-7.7,2.3-17.6,5.9-26.9,5.9",
    style: {
      fill: "#393230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path384",
    d: "M103.11,105.3c-.1-.2-.2-.3-.2-.5,0,.2.1.3.2.5",
    style: {
      fill: "#4f5352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path386",
    d: "M68.61,73.3h0m.1,0h0m.1-.1h0m.1,0h0m.1,0h0m.2,0h0",
    style: {
      fill: "#7da3a0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path388",
    d: "M102.81,104.8c-3.6-7.6-21.8-22.1-38.4-22.1a23.26,23.26,0,0,0-14,4.4c2.7-7,8.3-11.9,18.2-13.8h.6A14.07,14.07,0,0,1,72,73c12.1-.1,22.6,13.3,30.8,31.8",
    style: {
      fill: "#4f5352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path390",
    d: "M92.41,187.3a140,140,0,0,1-5.1-17.2c-1.4-5.8-2.6-11.5-3.7-17.3s-2.1-11.6-3-17.4-1.8-11.6-2.9-17.6c3.8,4.8,6.3,10.5,8.3,16.2a117.38,117.38,0,0,1,4.6,17.4,152,152,0,0,1,2.3,17.8,99.84,99.84,0,0,1-.5,18.1",
    style: {
      fill: "#393230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path392",
    d: "M960.11,75.8c-37.8-12-81,122.2-63.9,130.1s46.1,24.4,56.8-19.6c12.5-52.1,44.8-98.5,7.1-110.5",
    style: {
      fill: "#3b3f3e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path394",
    d: "M898.11,206.8c-.5-.2-1-.5-1.4-.7h0a6.11,6.11,0,0,0,1.4.7h0",
    style: {
      fill: "#495a57"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path396",
    d: "M926,215.6c-9.6,0-19.8-5-27.9-8.8h0c8,3.8,18.2,8.8,27.9,8.8h0",
    style: {
      fill: "#5b6e6b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path398",
    d: "M926,215.6c-9.6,0-19.8-5-27.9-8.8-.5-.2-1-.5-1.4-.7-.2-.1-.3-.1-.5-.2h0c-1.9-.9-3-3.2-3.5-6.7,10.5.2,24.3,5.7,34,5.7H928c12.5-.7,23-45.2,48.6-94.3-4,20.4-16.8,47.3-23.7,75.9-5.5,22.5-15.8,29.1-26.9,29.1",
    style: {
      fill: "#393230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path400",
    d: "M925.71,98.1h0m0,0c0-.1.1-.1,0,0,.1-.1,0-.1,0,0m.1-.2.1-.1a.1.1,0,0,1-.1.1m.1-.1.1-.1a.1.1,0,0,0-.1.1m.1-.1c9.1-13.5,19.3-22.6,29.2-22.6h0c-9.9-.1-20.1,9.1-29.2,22.6",
    style: {
      fill: "#6e9895"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path402",
    d: "M960.51,75.9h0m-.1,0h0m-.1,0h0m-.1-.1h0m-.2,0a15.31,15.31,0,0,0-4.7-.7h0a13.1,13.1,0,0,1,4.7.7",
    style: {
      fill: "#648c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path404",
    d: "M895.31,171.8c5.2-23.2,16.6-53.3,30.3-73.7h0a.1.1,0,0,1,.1-.1v-.2l.1-.1h0l.1-.1h0C935,84.1,945.21,75,955.11,75h.1a14.87,14.87,0,0,1,4.7.7h.5c9.7,3.2,14.6,8.8,16.4,16.2h0A20.93,20.93,0,0,0,962,85.5c-16.6.2-39.8,21.1-66.7,86.3",
    style: {
      fill: "#4f5352"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path406",
    d: "M922.21,186a98.23,98.23,0,0,1,2-18,148.48,148.48,0,0,1,4.6-17.4,127.05,127.05,0,0,1,6.8-16.7c2.8-5.3,5.9-10.7,10.4-15-1.9,5.8-3.5,11.4-5.2,17s-3.4,11.2-5.3,16.8-3.8,11.2-6,16.7a128.65,128.65,0,0,1-7.3,16.6",
    style: {
      fill: "#393230"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path408",
    d: "M293.81,206.6H210a7.38,7.38,0,0,1-7.4-7.4V187a7.38,7.38,0,0,1,7.4-7.4h83.8c-9,9.2-9.6,18.2,0,27",
    style: {
      fill: "#ebeef3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path410",
    d: "M293.81,179.7c-84.4-.7-93.6-4.5-93.6,17.2,0,13.9,9.9,8.5,93.2,10.3",
    style: {
      fill: "none",
      stroke: "#e04d46",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "4.253200054168701px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path412",
    d: "M220,191.5c2.8-.3,5.6-.4,8.4-.5s5.6-.2,8.4-.2h8.4q4.2,0,8.4.3c-2.8.3-5.6.4-8.4.5l-8.4.3h-8.4c-2.8-.1-5.6-.2-8.4-.4",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path414",
    d: "M263.81,198.2c2-.2,4-.4,6-.5s4-.1,6-.2,4,0,6,.1,4,.1,6,.4c-2,.2-4,.4-6,.5s-4,.1-6,.2-4,0-6-.1-4-.2-6-.4",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path416",
    d: "M275.71,185.3a50.53,50.53,0,0,1,6.7-.6,37.8,37.8,0,0,1,6.7.5,41.09,41.09,0,0,1-13.4.1",
    style: {
      fill: "#5e8c89"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path418",
    d: "M231.11,191.5h0c.3,2.5.4,5,.6,7.5a.51.51,0,0,0,.9.3,33.28,33.28,0,0,1,3.9-3.6c.2-.2.5-.4.7-.3s.3.2.5.3l3.6,4.1a.53.53,0,0,0,.9-.2,29.83,29.83,0,0,0,.7-7.9.56.56,0,0,0-.6-.5c-3.9,0-7.2.1-11.2.3",
    style: {
      fill: "#e04d46"
    }
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCouch1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/couch1.680743afb5e72718f0cfbb77aaaa1d38.svg";